import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id FF83529F-FAA5-4FAD-9EE8-9F9A74409F93
 * name skip-previous-circle-outline
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/skip-previous-circle-outline.svg
 * tags
 */
export const SkipPreviousCircleOutlineIcon = createSvgIcon(<><path d="M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4C7.59,4 4,7.59 4,12C4,16.41 7.59,20 12,20C16.41,20 20,16.41 20,12C20,7.59 16.41,4 12,4M16,8V16L11,12M10,8V16H8V8" /></>, 'SkipPreviousCircleOutlineIcon');
export default SkipPreviousCircleOutlineIcon